import {Component, Inject} from 'ng-metadata/core';
import {ChangeLangService} from "../infra/lang/changeLang.service";
import {MappingTablesCache} from "../mappingTablesCache/mappingTablesCache.service";
import {getCaptcha, getVid} from "../appConfig/appConfigForward";
import {ReportProblemService} from "./reportProblem.service";
import {PrimolyticsService} from '../analytics/primolytics.service';
import {MediaQueries} from "../infra/mediaQueries.service";

@Component({
    selector: 'prm-report-problem',
    templateUrl: 'components/reportProblem/report-problem.html',
})

export class PrmReportProblem {

    /* Windows pages */
    public START_PAGE: string = 'start';
    public FORM_PAGE: string = 'form';
    public SUCCESS_PAGE: string = 'success';
    public FAILURE_PAGE: string = 'failure';
    public currentWindow: string = this.START_PAGE;

    private emailRegExAll = /^(([a-zA-Z0-9\.\!\#\$\%\&\'\*\+\-\/\=\?\^\_\`\{\|\}\~]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([;|,]\s*(([a-zA-Z0-9\.\!\#\$\%\&\'\*\+\-\/\=\?\^\_\`\{\|\}\~]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/;
    private captchaConfigValue = getCaptcha();
    private _sendMailInProgress: boolean = false;
    private _selectedCategory: string;
    private _openCloseReportProblemButton: boolean = false;
    private _options: Array<any>;
    private _address: string = "";
    private _description: string = "";
    private _captchaResponse: string = "";
    private _showCaptchaError: boolean = false;
    private _showMandatoryFieldsError: boolean = false;
    private _showInvalidEmailAddrError: boolean = false;
    private MIN_NUM_OF_CATEGORIES: number = 1;
    private MAX_NUM_OF_CATEGORIES: number = 4;

    private KEY_CODE = {
        ENTER: 13,
        ESCAPE: 27,
        UP_ARROW: 38,
        DOWN_ARROW: 40,
        TAB: 9,
    };

    constructor(private changeLangService: ChangeLangService,
                private reportProblemService: ReportProblemService,
                private mappingTablesCache: MappingTablesCache,
                private primolyticsService: PrimolyticsService,
                private mediaQueries: MediaQueries,
                @Inject('actionIcons') private actionIcons: Object,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$mdMenu') private $mdMenu: ng.material.IMenuService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$element') private $element: JQuery) {
        this._sendMailInProgress = false;
    }

    ngOnInit(event) {
        this.buildOptions();

        this.$scope.$watch(() => this.openFromMainMenu, (newVal, oldVal) => {
            if (newVal) {
                this.$timeout(() => {
                    let open = document.getElementById("reportProblem") as HTMLElement;
                    open.click();

                    this.openFromMainMenu = false;
                }, 0);
            }
        });
    }

    private keyDownSupport(e) {
        if (e.keyCode === 27) {
            this.openCloseReportProblemButton = false;
            this.$timeout(() => {
                this.currentWindow = this.START_PAGE;
            }, 300);
            this.focusOnMainBtn();
        }
    }

    private keyDownSupportGoToMainBtn(e) {
        let sendBtn = document.querySelector('.report-problem-btn');
        let emailInput = document.querySelector('#emailAdressInput')
        if (sendBtn && e.keyCode === 9) {
            e.preventDefault();
            sendBtn.focus();
        }
        if (emailInput && e.keyCode === 9 && e.shiftKey) {
            e.preventDefault();
            emailInput.focus();
        }
    }

    private keyDownSupportOptionBtn(e) {
        let closeBtn = document.querySelector('.report-problem-btn');
        let currentOptionIndex = parseInt(e.target.id.split('catOptionIndex_')[1]);
        if (closeBtn && e.keyCode === 9 && this._options.length === currentOptionIndex + 1) {
            if (!e.shiftKey) {
                e.preventDefault();
                closeBtn.focus();
            }
        }
    }

    public keyDownSupportReportBtn(e) {
        let param = '#catOptionIndex_' + (this._options.length-1);
        let lastCatOption = document.querySelector(param);
        if(!lastCatOption){
            lastCatOption = document.querySelector('#sendReport')
        }
        if (e.keyCode === 9 && e.shiftKey && lastCatOption) {
            e.preventDefault();
            lastCatOption.focus();
        }

    }

    private buildOptions() {
        let limit = this.reportProblemService.getCategoryRowFromMt('Number of categories')[0].target;

        this.options = [];
        for (let i = this.MIN_NUM_OF_CATEGORIES; i <= this.MAX_NUM_OF_CATEGORIES; i++) {
            let option = {};
            option.value = 'report.option' + i;
            option.code = 'report.option' + i;
            option.ariaCode = 'nui.aria.reportCategory' + i;
            this.options.push(option);
        }

        const minLimit = Math.min(limit, 4);
        this.options = this.options.slice(0, minLimit);

        this.selectedCategory = this.options[0].value;
    }

    private goToPage(page) {
        this.currentWindow = page;
    }

    private runBeacon(operation) {
        this.primolyticsService.doBeaconReport({
            'p': 'general',
            'op': operation
        }, this.primolyticsService.getTimestamp());
    }

    public resetErrors(){
        this.showCaptchaError = false;
        this.showMandatoryFieldsError = false;
        this.showInvalidEmailAddrError = false;
    }


    public runCategoryBeacon(categoryIndex) {
        this.runBeacon('openCategory' + categoryIndex);
    }

    public runOperationBeacon(operation) {
        this.runBeacon(operation);
    }

    public toggleReportProblem() {
        this.resetErrors();

        this.openCloseReportProblemButton = !this.openCloseReportProblemButton;

        if (this.openCloseReportProblemButton) {
            this.runOperationBeacon('openReportProblem');
            this.cleanInputs();
        }
        else {
            this.runOperationBeacon('closeReport');
        }


        this.$timeout(() => {
            this.currentWindow = this.START_PAGE;
        }, 300);

        if (this._openCloseReportProblemButton) {
            this.$timeout(() => {
                let drop = document.querySelector('.report-options .button-link');
                if (drop) {
                    drop.focus();
                }
            }, 0);
        } else {
            let close = document.querySelector('#reportProblem');
            if (close) {
                close.focus();
            }
        }

        if (this.mediaQueries.xs && this.openCloseReportProblemButton === false) {
            document.body.style.overflow = '';
        }
    }

    public isRTL() {
        return this.changeLangService.direction === 'rtl';
    }

    public selectCategory(category) {
        this.goToPage(this.FORM_PAGE);

        this.selectedCategory = category;

        this.$timeout(() => {
            let drop = document.querySelector('.categories-drop-down');
            if (drop) {
                drop.focus();
            }
        }, 0);

        // Set mandatory fields by configuration
        this.setMandatoryFieldsByConfiguration();
    }

    public sendEmail(event) {
        // The form is not valid if we have validation error in captcha / required mandatory fields / invalid email address
        if (this.isFormNotValid()) {
            return;
        }

        this.sendMailInProgress = true;

        let successAction = angular.bind(this, this.successfullSendAction, event);
        let failedAction = angular.bind(this, this.failedSendAction, event);

        let sendEmailPromise = this.reportProblemService.sendEmail(this.selectedCategory, this.address, this.description, this.captchaResponse);
        sendEmailPromise.then((response) => successAction(response), (response) => failedAction(response));
    }

    get emailRegEx() {
        return this.emailRegExAll;
    }

    get isCaptcha() {
        return this.captchaConfigValue.isActiveCapcha == 'Y';
    }

    get capchaPublicKey() {
        return this.captchaConfigValue.public_key;
    }

    public setWidgetId(widgetId){
        //console.log("Get widgetId from capture :" + widgetId);
    }

    public setResponse(response){
        this.showCaptchaError = false;
        this.captchaResponse = response;
    }

    private cleanInputs() {
        this.description = "";
        this.address = "";
    }

    private focusOnCloseBtn() {
        this.$timeout(() => {
            let closeBtn = document.querySelector('.close-report-btn');
            if (closeBtn) {
                closeBtn.focus();
            }
        }, 0);
    }

    private focusOnMainBtn() {
        if (!this._openCloseReportProblemButton) {
            this.$timeout(() => {
                let closeBtn = document.querySelector('.report-problem-btn');
                if (closeBtn) {
                    closeBtn.focus();
                }
            }, 0);
        }
    }

    public focusOnFirstCat() {
        this.$timeout(() => {
            let drop = document.querySelector('.report-options .button-link');
            if (drop) {
                drop.focus();
            }
        }, 0);
    }

    private isFormNotValid(){
        this.showMandatoryFieldsError = this.isOneOfMandatoryFieldsAreEmpty();
        this.showCaptchaError = this.isCaptcha && this.captchaResponse.length == 0 && !this.showMandatoryFieldsError;
        this.showInvalidEmailAddrError = this.showInvalidEmailAddrErrorByConfig();

        return this.showCaptchaError || this.showMandatoryFieldsError || this.showInvalidEmailAddrError;
    }

    // If email is mandatory field --> make complete validation also on empty string
    // If email is not mandatory field
    //      If email address is empty (empty string) --> don't make complete validation --> don't show email invalid error
    //      If email address is not empty (something typed) --> make complete validation also on empty string
    private showInvalidEmailAddrErrorByConfig(){
        return this.reportProblemService.isFormEmailMandatory() ? !this.emailRegEx.test(this.address) : ((this.address == "") ? false : !this.emailRegEx.test(this.address));
    }

    private isOneOfMandatoryFieldsAreEmpty(){
        let isDescEmpty = this.reportProblemService.isFormDescriptionMandatory() ? this.description == "" : false;
        let isEmailEmpty = this.reportProblemService.isFormEmailMandatory() ? this.address == "" : false;

        return isDescEmpty || isEmailEmpty;
    }

    private setMandatoryFieldsByConfiguration(){
        if (this.reportProblemService.isFormDescriptionMandatory()) {
            this.setMandatoryFieldByConfiguration('descriptionTextArea');
        }
        if (this.reportProblemService.isFormEmailMandatory()) {
            this.setMandatoryFieldByConfiguration('emailAdressInput');
        }
    }

    private setMandatoryFieldByConfiguration(id){
        this.$timeout(() => {
            let mandatoryField = document.getElementById(id) as HTMLElement;
            if (mandatoryField) {
                mandatoryField.setAttribute('required', 'required');
                let container = angular.element(mandatoryField.closest('md-input-container'));
                container.addClass('md-required');
            }
        }, 0);
    }

    private successfullSendAction() {
        this.sendMailInProgress = false;
        this.captchaResponse = "";
        this.goToPage(this.SUCCESS_PAGE);
        this.cleanInputs();
        this.focusOnCloseBtn();
    }

    private failedSendAction() {
        this.sendMailInProgress = false;
        this.captchaResponse = "";
        this.goToPage(this.FAILURE_PAGE);
        this.runOperationBeacon('sendReportFailed');
        this.cleanInputs();
        this.focusOnCloseBtn();
    }

    // --- Getters and Setters Section ---
    get sendMailInProgress() {
        return this._sendMailInProgress;
    }

    set sendMailInProgress(bool) {
        this._sendMailInProgress = bool;
    }

    get openCloseReportProblemButton() {
        return this._openCloseReportProblemButton;
    }

    set openCloseReportProblemButton(value) {
        this._openCloseReportProblemButton = value;
    }

    get options() {
        return this._options;
    }

    set options(options) {
        this._options = options;
    }

    get selectedCategory() {
        return this._selectedCategory;
    }

    set selectedCategory(category) {
        this._selectedCategory = category;
    }

    get address() {
        return this._address;
    }

    set address(value) {
        this._address = value;
    }

    get description() {
        return this._description;
    }

    set description(value) {
        this._description = value;
    }

    get openFromMainMenu() {
        return this.reportProblemService._openFromMainMenu;
    }

    set openFromMainMenu(open) {
        this.reportProblemService._openFromMainMenu = open;
    }

    get captchaResponse() {
        return this._captchaResponse;
    }

    set captchaResponse(captcha) {
        this._captchaResponse = captcha;
    }

    get showCaptchaError() {
        return this._showCaptchaError;
    }

    set showCaptchaError(bool) {
        this._showCaptchaError = bool;
    }

    get showMandatoryFieldsError() {
        return this._showMandatoryFieldsError;
    }

    set showMandatoryFieldsError(bool) {
        this._showMandatoryFieldsError = bool;
    }

    get showInvalidEmailAddrError() {
        return this._showInvalidEmailAddrError;
    }

    set showInvalidEmailAddrError(bool) {
        this._showInvalidEmailAddrError = bool;
    }

    private recaptchaPublicKeyIsNotValid() {
        return this.isCaptcha && !this.recaptchaIframeExists();
    }

    private recaptchaIframeExists() {
        return document.querySelector('iframe[title="reCAPTCHA"]');
    }

    public getRecaptchaErrorMessage(): String {
        return this.recaptchaPublicKeyIsNotValid() ? 'captcha.invalidSiteKey' : 'captcha.notselected';
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/reportProblem/reportProblem.directive.ts